



























































import { Component, Prop, Vue } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import { IMenuRoute } from "@/models/routes";
import { UserMetaKeys } from "@/data/enums/users";
import { mapGetters } from "vuex";
import { ClientRoutes } from "@/data/enums/router";

@Component({
  components: {
    "contract-categories-provider": () =>
      import(
        "@/components/app/global/contractCategories/contractCategoriesProvider.vue"
      )
  },
  computed: {
    ...mapGetters({
      hasDelegatedProducts: "auth/client/hasDelegatedProducts"
    })
  }
})
export default class ClientContractProducts extends Vue {
  // Props

  @Prop({ default: () => () => [] })
  public routes!: () => IMenuRoute[];

  // Data

  public form = this.initForm();
  public hasDelegatedProducts!: boolean;
  public isLoading = true;

  // Computed

  public get defaultRoutes(): IMenuRoute[] {
    return [
      {
        label: this.$t("_.all_products_and_services"),
        to: {
          name: ClientRoutes.PRODUCTS
        }
      },
      {
        label: this.$t("_.subscriptions"),
        to: {
          name: ClientRoutes.SUBSCRIPTIONS
        }
      },
      {
        label: this.$t("_.one_time_purchases"),
        to: {
          name: ClientRoutes.ONE_TIME_PURCHASES
        }
      }
    ];
  }

  // Life-cycle methods

  public created() {
    this.checkForSolitaryProduct();
  }

  // Methods

  public async checkForSolitaryProduct() {
    try {
      const { total, data } = await this.$store.dispatch(
        `data/${DataModules.CONTRACTS_PRODUCTS}/list`,
        {
          ignoreStored: true,
          returnData: false,
          storeData: false,
          params: {
            limit: 1
          },
          vm: this
        }
      );
      // Redirect if solitary
      if (total === 1)
        return this.$router.push({
          name: ClientRoutes.CONTRACT_PRODUCT,
          params: {
            contractId: data[0].contract_id as string,
            productId: data[0].id as string
          }
        });
    } catch {
      // Silent catch – check non-critical
    } finally {
      this.isLoading = false;
    }
  }

  public initForm() {
    return {
      exclude_delegated: parseInt(
        this.$store.getters["user/meta"](
          UserMetaKeys.UI_PRODUCTS_EXCLUDE_DELEGATES
        ) ?? `0`
      )
    };
  }

  public onToggleDelegated(val: number) {
    this.$set(this.form, "exclude_delegated", val);
    this.$store.dispatch("user/addMeta", {
      [UserMetaKeys.UI_PRODUCTS_EXCLUDE_DELEGATES]: `${val}`
    });
  }
}
